(() => {
  const hero = document.getElementById('hero-product-home');
  const variantId = hero && hero.dataset.variantId;
  if (!hero || !variantId) return;

  const button = document.createElement('button');
  button.type = 'button';
  button.className = 'sticky-atc-home';
  button.dataset.test = 'sticky-atc';
  button.dataset.variantId = variantId;
  button.textContent = `Legg i kurv · ${hero.dataset.variantPrice || '899,-'}`;
  document.body.appendChild(button);

  const style = document.createElement('style');
  style.textContent = `.sticky-atc-home{position:fixed;left:14px;right:14px;bottom:14px;z-index:60;border:0;border-radius:999px;background:#0b3b5a;color:#fff;padding:16px 20px;font-weight:800;box-shadow:0 16px 40px rgba(0,0,0,.24);display:none}.sticky-atc-home.is-visible{display:block}@media(min-width:768px){.sticky-atc-home{display:none!important}}`;
  document.head.appendChild(style);

  const goToCheckout = () => {
    const root = window.Shopify?.routes?.root || '/';
    window.location.href = `${root}checkout`;
  };

  const add = async (event) => {
    event?.preventDefault();
    const trigger = event?.currentTarget || button;
    trigger.disabled = true;
    button.disabled = true;

    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: Number(variantId), quantity: 1 }),
      });

      if (!response.ok) {
        const errorData = await response.json().catch(() => null);
        throw new Error(errorData?.description || 'Kunne ikke legge varen i handlekurven.');
      }

      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event: 'add_to_cart', source: 'sticky_home_atc', variant_id: variantId });
      window.dataLayer.push({ event: 'begin_checkout', source: 'home_direct_checkout', variant_id: variantId });
      goToCheckout();
    } catch (error) {
      console.error(error);
    } finally {
      trigger.disabled = false;
      button.disabled = false;
    }
  };

  document.querySelectorAll('[data-home-atc]').forEach((el) => {
    el.addEventListener('click', add);
  });
  button.addEventListener('click', add);

  const update = () => {
    const email = document.getElementById('email-capture-home');
    const pastHero = window.scrollY > hero.offsetHeight + 600;
    const nearEmail = email && email.getBoundingClientRect().top < window.innerHeight;
    button.classList.toggle('is-visible', pastHero && !nearEmail);
  };
  window.addEventListener('scroll', update, { passive: true });
  window.addEventListener('resize', update);
  update();
})();
